import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-work-order-gift-card-details',
  templateUrl: './work-order-gift-card-details.component.html'
})
export class WorkOrderGiftCardDetailsComponent {
  @Input() giftCards: any;
}
